const ROOTS = {
  AUTH: "/auth",
  AUTH_DEMO: "/auth-demo",
  DASHBOARD: "/dashboard",
};

export const paths = {
  page403: "/403",
  page404: "/404",
  page500: "/500",
  auth: {
    login: `${ROOTS.AUTH}/login`,
  },
  dashboard: {
    root: `${ROOTS.DASHBOARD}`,
  },
};
